// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d50a19e5","284":"a715699e","297":"ddb6a4c0","470":"ce7568d2","586":"1016102c"}[chunkId] + ".chunk.js";
};